import globalstyle from './globalStyle';
import themedefault from './defaultTheme';

const themes = {
  globalstyle,
  themedefault,
};

export default themes;
